import CountryItem from "./CountryItem";
import { countries } from "./countries";

export default class CountryHolder {
  public saveCountry = (countryItem: CountryItem): void => {
    localStorage.setItem("country", JSON.stringify(countryItem));
  };

  public getCountry = (): CountryItem => {
    const countryItem = localStorage.getItem("country");

    if (countryItem) {
      return JSON.parse(countryItem);
    } else {
      return countries[0];
    }
  };
}
